import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import _ from 'lodash'
import { DataTablePagination } from '@/types/_'
import Apis from '@/Apis/_'

type Mode = 'CREATE' | 'EDIT'

type SetSuporteModal = {
  name: string,
  value: boolean,
}

type SuporteModal = {
  convenio: boolean,
  convenioPlano: boolean,
}

interface ConvenioPlano {
  id: string,
  convenioId: string,
  nome: string,
  status: string,
  hisId: string,
  convenioHisId: string,
  hospitalId?: string,
}

interface Convenio {
  id: string,
  nome: string,
  particular: boolean,
  status: string,
  codigoOperadora: string,
  codigoNaOperadora?: string,
  hospitalRealizaCotacao: boolean,
  geraNecessidadeDeAutorizacaoNoHis?: boolean,
  convenioFazCodificacaoDeOpme: boolean,
  registroANS: string,
  tempoParaAutorizacao: null,
  hospitalId: string,
  hisId?: string,
  prazoEmDiasParaTriagem: number,
  prazoMaximoEmDiasParaAgendamento: number,
  prazoEmDiasParaSolicitarCirurgiaComOpme: number,
  prazoEmDiasParaSolicitarCirurgiaSemOpme: number,
  prazoEmDiasDeAguardamentoPosTriagem: number,
  tipoTabelaProcedimento: string,
  centralDeGuiasSolicitaAutorizacaoNoConvenio: boolean,
  fazAutorizacaoAntesDaReservaDeSala: boolean,
  utilizaAguardandoPriorizacao: boolean,
  utilizaAutorizadoParaAgendar: boolean,
  enviaUmaDiariaParaHospitalDiaNaAutorizacao: boolean,
  mascaraCarteirinha?: string,
}

@Module({ namespaced: true, name: 'SuporteConveniosStore' })
export default class SuporteConveniosStore extends VuexModule {
  public hospitalId: string = ''
  public searchConvenio: string = ''

  public mode: Mode = 'CREATE'

  public modal: SuporteModal = {
    convenio: false,
    convenioPlano: false,
  }

  @Mutation
  setSearchConvenio(val: string) {
    this.searchConvenio = val
  }

  @Mutation
  clearSearchConvenio() {
    this.searchConvenio = ''
  }

  @Mutation
  setModal(modal: SetSuporteModal) {
    this.modal[modal.name] = modal.value
  }

  @Mutation
  setHospitalId(value: string) {
    this.hospitalId = value
  }

  @Mutation
  clearHospitalId() {
    this.hospitalId = ''
  }

  @Mutation
  setMode(param: any) {
    this.mode = param.mode
  }

  /** Convênio e plano */
  private convenioDefault: Convenio = {
    codigoOperadora: '',
    id: '',
    nome: '',
    particular: false,
    status: 'Ativo',
    hospitalRealizaCotacao: true,
    convenioFazCodificacaoDeOpme: true,
    geraNecessidadeDeAutorizacaoNoHis: false,
    codigoNaOperadora: '',
    registroANS: '',
    tempoParaAutorizacao: null,
    hospitalId: '',
    hisId: '',
    prazoEmDiasParaTriagem: 0,
    prazoMaximoEmDiasParaAgendamento: 0,
    prazoEmDiasParaSolicitarCirurgiaComOpme: 0,
    prazoEmDiasParaSolicitarCirurgiaSemOpme: 0,
    prazoEmDiasDeAguardamentoPosTriagem: 0,
    tipoTabelaProcedimento: 'TUSS',
    centralDeGuiasSolicitaAutorizacaoNoConvenio: false,
    fazAutorizacaoAntesDaReservaDeSala: false,
    utilizaAguardandoPriorizacao: false,
    utilizaAutorizadoParaAgendar: false,
    enviaUmaDiariaParaHospitalDiaNaAutorizacao: false,
    mascaraCarteirinha: '',
  }

  public convenios: Convenio[] = [{ ...this.convenioDefault }]
  public convenio: Convenio = { ...this.convenioDefault }

  private convenioPlanoDefault: ConvenioPlano = {
    convenioHisId: '',
    convenioId: '',
    hisId: '',
    id: '',
    nome: '',
    status: '',
  }

  public convenioPlanos: ConvenioPlano[] = []
  public convenioPlano: ConvenioPlano = { ...this.convenioPlanoDefault }
  public novoConvenioPlano: ConvenioPlano = { ...this.convenioPlanoDefault }
  private paginationConvenioDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 5,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [5, 10, 25],
  }

  get paginationDefault() {
    return this.paginationConvenioDefault
  }

  public paginationConvenio: DataTablePagination = { ...this.paginationConvenioDefault }

  @Mutation
  setConvenios(value: Convenio[]) {
    this.convenios = value
  }

  @Mutation
  clearConvenio() {
    this.searchConvenio = ''
    this.convenio = { ...this.convenioDefault }
    this.convenioPlano = { ...this.convenioPlanoDefault }
    this.convenioPlanos = []
  }

  @Mutation
  setConvenio(value: Convenio) {
    this.convenio = {
      ...value,
      prazoEmDiasParaTriagem: value.prazoEmDiasParaTriagem || 0,
      prazoMaximoEmDiasParaAgendamento: value.prazoMaximoEmDiasParaAgendamento || 0,
      prazoEmDiasParaSolicitarCirurgiaComOpme: value.prazoEmDiasParaSolicitarCirurgiaComOpme || 0,
      prazoEmDiasParaSolicitarCirurgiaSemOpme: value.prazoEmDiasParaSolicitarCirurgiaSemOpme || 0,
      centralDeGuiasSolicitaAutorizacaoNoConvenio: value.centralDeGuiasSolicitaAutorizacaoNoConvenio || false,
      fazAutorizacaoAntesDaReservaDeSala: value.fazAutorizacaoAntesDaReservaDeSala || false,
      enviaUmaDiariaParaHospitalDiaNaAutorizacao: value.enviaUmaDiariaParaHospitalDiaNaAutorizacao || false,
      mascaraCarteirinha: value.mascaraCarteirinha || '',
    }
  }

  @Mutation
  clearConvenios() {
    this.convenios = [{ ...this.convenioDefault }]
  }

  @Mutation
  setConvenioPlanos(value: ConvenioPlano[]) {
    this.convenioPlanos = value
  }

  @Mutation
  clearConvenioPlanos() {
    this.convenioPlanos = []
  }

  @Mutation
  setConvenioPlano(value: ConvenioPlano) {
    this.convenioPlano = value
  }

  @Mutation
  clearConvenioPlano() {
    this.convenioPlano = { ...this.convenioPlanoDefault }
    this.convenioPlanos = []
  }

  @Mutation
  setConvenioPlanoById(id: string) {
    const filter = this.convenioPlanos.filter(c => c.id === id)[0]
    if (filter) {
      const j = JSON.stringify(filter)
      this.convenioPlano = JSON.parse(j)
    }
  }

  @Mutation
  clearNovoConvenioPlano() {
    this.novoConvenioPlano = { ...this.convenioPlanoDefault }
  }

  @Mutation
  clearConvenioAutorizacaoCampos() {
    this.convenio.utilizaAguardandoPriorizacao = false
    this.convenio.utilizaAutorizadoParaAgendar = false
  }

  @Action
  async getConvenios() {
    try {
      const request = await Apis.Agendamento.SuporteApi.getAllConveniosSuporte(this.hospitalId)
      if (request.success) this.context.commit('setConvenios', request.data)
      return request
    } catch (error) {
      this.context.commit('setConvenios', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getConvenioById(id: string) {
    const params: any = {
      hospitalId: this.hospitalId,
      convenioId: id,
    }

    const request = await Apis.Agendamento.SuporteApi.getConvenioById(params)
    if (request.success) {
      const { commit } = this.context
      commit('setConvenio', request.data)
    }

    return request
  }

  @Action
  async getAllConvenioPlanoByConvenio() {
    const { hospitalId, convenio } = this
    const request = await Apis.Agendamento.SuporteApi.getAllConvenioPlanoByConvenio(hospitalId, convenio.id)
    if (request.success) {
      const { commit } = this.context
      commit('setConvenioPlanos', request.data)
    }

    return request
  }

  @Action
  async upsertConvenioHospital() {
    const params: Convenio = this.convenio
    params.hospitalId = this.hospitalId
    if (this.mode === 'CREATE') params.status = 'Ativo'

    Object.entries(params).forEach(([key, value]) => {
      // @ts-ignore
      if (['', null, undefined].includes(value)) delete params[key]
    })

    const request = await Apis.Agendamento.SuporteApi.upsertConvenioHospital(params)
    if (request.success) {
      params.id = request.data.id
    }

    return request
  }

  @Action
  async upsertConvenioPlanoHospital() {
    const params: ConvenioPlano = this.modal.convenioPlano ? this.novoConvenioPlano : this.convenioPlano
    params.hospitalId = this.hospitalId
    params.convenioId = this.convenio.id

    Object.entries(params).forEach(([key, value]) => {
      if (['', null, undefined].includes(value as any)) delete params[key]
    })

    const request = await Apis.Agendamento.SuporteApi.upsertConvenioPlanoHospital(params)
    if (request.success) {
      params.id = request.data.id
    }

    return request
  }

  @Action
  async upsertCategoriaPlano() {
    try {
      const request = Apis.Agendamento.SuporteApi.upsertCategoriaPlano({
        categoriaId: '',
        planoId: '',
        hospitalId: this.hospitalId,
        status: 'Ativo',
      })
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
